import { Reveal, Eyebrow } from "./Reveal";

const SERVICES = [
  { n: "01", title: "Custom Business Websites", copy: "Professional websites designed around your business, brand and goals." },
  { n: "02", title: "Landing Pages", copy: "Focused, conversion-oriented pages designed for specific products, services or campaigns." },
  { n: "03", title: "Website Redesigns", copy: "Modernise an outdated website with a cleaner design, stronger UX and responsive experience." },
  { n: "04", title: "Responsive Development", copy: "Websites designed to work beautifully across desktop, tablet and mobile." },
  { n: "05", title: "Custom Features", copy: "Forms, galleries, booking interfaces, interactive sections and other functionality based on your requirements." },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-surface border-y border-line">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <Reveal>
          <div className="flex items-baseline gap-4">
            <span className="font-heading text-xl text-accent">02</span>
            <Eyebrow>Services</Eyebrow>
          </div>
          <h2 className="mt-6 font-heading font-medium tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl text-ink">
            What I can build for you.
          </h2>
        </Reveal>

        <div className="mt-14 md:mt-20 grid md:grid-cols-2 border-t border-l border-line">
          {SERVICES.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.06} className={i === SERVICES.length - 1 ? "md:col-span-2" : ""}>
              <div
                data-testid={`service-block-${s.n}`}
                className="group h-full border-b border-r border-line p-8 md:p-12 hover:bg-ivory transition-colors duration-500"
              >
                <p className="font-heading text-lg text-accent">{s.n}</p>
                <h3 className="mt-4 font-heading text-2xl md:text-3xl font-medium tracking-tight uppercase text-ink">
                  {s.title}
                </h3>
                <p className="mt-3 text-base leading-relaxed text-stone max-w-md">{s.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
